﻿import { Component, Input, ElementRef, Renderer2 } from '@angular/core';
import { AbstractControlDirective, AbstractControl, FormGroup, FormControl } from '@angular/forms';
import { HelperService } from '../../services/helper.service'

@Component({
    selector: 'errors',
    template: `
    <span class="errorInlineMessage" *ngIf="showErrors()">
      {{errors()}}
    </span>
  `
})

export class ErrorsComponent {

    private static readonly errorMessages = {
        'required': () => ({ rank: 1, message: 'Required' }),
        'invalid': () => ({ rank: 1, message: 'Invalid' }),
        'maxlength': (params) => ({ rank: 2, message: 'Invalid' }),
        'pattern': (params) => ({ rank: 2, message: "Invalid" }),
        'noZeroLength': (params) => ({ rank: 2, message: "Invalid" }),
        'min': (params) => ({ rank: 2, message: 'Invalid' }),
        'max': (params) => ({ rank: 2, message: 'Invalid' }),
        'email': (params) => ({ rank: 2, message: "Invalid" })
    };
    
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private helperService: HelperService) { }

    @Input()    
    private control: FormControl; 
    @Input()
    private componentClass: any;
    
    showErrors(): boolean {
        
        var cname = this.getControlName(this.control);        
        var isInvalid = (this.control && this.control.errors) ? true : false;

        if (!this.control && (typeof this.componentClass === "object"))
        {            
            isInvalid = typeof this.componentClass[0] === 'boolean' ? this.componentClass[0] : null;
        }
        else
        if (isInvalid)
        {
            var submitted = this.componentClass ? (this.componentClass.submitted ? true : false) : null;
            var verifyClicked = this.componentClass ? (this.componentClass.verifyClicked ? true : false) : null;            
            var isCondition = typeof this.componentClass === 'boolean' ? this.componentClass : null;

            var isDirty = this.helperService.activeBrowser === "IE-11" ? false : this.control.dirty;            

            if (isCondition != null)
            {
                isInvalid = isInvalid && (isCondition || isDirty);
            }
            else if (this.control.hasError("pattern"))
            {
                isInvalid = isInvalid || isDirty;
                if (submitted != null) {
                    isInvalid = isInvalid || submitted;
                }
            }
            else if (this.control.hasError("required")) {
                isInvalid = isInvalid || isDirty;
                if (verifyClicked != null)
                {
                    isInvalid = isInvalid || verifyClicked;
                }
            }
            else if (this.control.hasError("noZeroLength")) {
                if (submitted != null) {
                    isInvalid = isInvalid || submitted;
                }
            }
        }

        var attr = this.el.nativeElement.getAttribute('locationTop');
        
        var parentElem = this.el.nativeElement.parentElement;

        if (parentElem) {
            if (isInvalid) {
                parentElem.classList.add('validationError');
            }
            else {
                parentElem.classList.remove('validationError');
            }
            
            if (attr == "")
            {                
                this.el.nativeElement.classList.add('messageLocationRightTop');
            }
        }    
            
        return isInvalid;
    }

    errors(): string {

        var error = "";
        if (this.control) {
            var errs = Object.keys(this.control.errors);
            var errlist = errs.map(field => this.getMessage(field, this.control.errors[field]))
            error = errlist.sort(function (er1, er2) { return er1.rank - er2.rank; })[0].message;
        }
        else
        {
            error = this.componentClass[1] ? this.componentClass[1] : "";
        }
        return error;
    }

    private getMessage(type: string, params: any) {
        return ErrorsComponent.errorMessages[type](params);
    }

    getControlName(c: AbstractControl): string | null {
        var result = "";
        if (c && c.parent) {
            const formGroup = c.parent.controls;
            result = Object.keys(formGroup).find(name => c === formGroup[name]) || null;
        }
        return result;
    }

    //activeBrowser = (function () {
    //    var ua = navigator.userAgent, tem,
    //        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    //    if (/trident/i.test(M[1])) {
    //        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    //        return 'IE-' + (tem[1] || '');
    //    }
    //    if (M[1] === 'Chrome') {
    //        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    //        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    //    }
    //    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    //    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    //    return M.join(' ');
    //})();

}
